"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

require("../../assets/css/components/form/Form.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form(props) {
        _classCallCheck(this, Form);

        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        _this.receivePropsOnce = 0;

        _this.validateFormFields = function (form, event) {
            form.querySelectorAll('.untouched.mdl-textfield.validate').forEach(function (i) {
                i.classList.remove('untouched');
                i.classList.add('touched');
            });
            var invalidFields = form.querySelectorAll('.invalid.mdl-textfield');
            if (invalidFields.length > 0) {
                event.preventDefault();
            } else {
                event.preventDefault();
                _this.props.onSubmit(event);
            }
        };

        _this.resetFields = function (form) {
            form.querySelectorAll('.mdl-textfield.validate').forEach(function (i) {
                i.classList.remove('touched');
                i.classList.remove('valid');
                i.classList.remove('dirty');
                i.classList.add('untouched');
                i.classList.add('invalid');
            });
        };

        _this.getForm = function () {
            if (_this.props.role) return _react2.default.createElement(
                "form",
                { className: 'mt-form ' + (_this.props.className || ""), method: _this.props.method || 'POST', autoComplete: _this.props.autoComplete || 'off', ref: function ref(form) {
                        return _this.form = form;
                    },
                    onSubmit: _this.onSubmit, onKeyPress: _this.onKeyPress, role: _this.props.role },
                _this.props.children
            );else return _react2.default.createElement(
                "form",
                { className: 'mt-form ' + (_this.props.className || ""), method: _this.props.method || 'POST', autoComplete: _this.props.autoComplete || 'off', ref: function ref(form) {
                        return _this.form = form;
                    },
                    onSubmit: _this.onSubmit, onKeyPress: _this.onKeyPress },
                _this.props.children
            );
        };

        _this.onKeyPress = _this.onKeyPress.bind(_this);
        return _this;
    }

    _createClass(Form, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            var form = _reactDom2.default.findDOMNode(this.form);
            if (form.querySelector('button[type="submit"]')) form.querySelector('button[type="submit"]').addEventListener('click', function (event) {
                _this2.validateFormFields(form, event);
            });
            if (form.querySelector('button[type="reset"]')) form.querySelector('button[type="reset"]').addEventListener('click', function (event) {
                _this2.resetFields(form);
            });
        }
    }, {
        key: "onSubmit",
        value: function onSubmit(event) {
            this.validateFormFields(this.form, event);

            if (this.props.onSubmit) this.props.onSubmit(event);
        }
    }, {
        key: "onKeyPress",
        value: function onKeyPress(event) {
            if (event.which === 13 && document.activeElement.getAttribute('type') !== 'checkbox') {
                this.validateFormFields(this.form, event);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return this.getForm();
        }
    }]);

    return Form;
}(_react.Component);

exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/Form.js
// module id = 192
// module chunks = 0